export const NEWS_TAGS = {
    ALL_NEWS: "GetAllNews",
} as const;